import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectAgentsAlphabetically, selectIsAgentsFetching } from "store/entities/agents";
import { selectCannedResponsesArray, selectIsCannedResponsesFetching } from "store/entities/canned-responses";
import { selectIsMailboxesFetching, selectMailboxesAlphabetically } from "store/entities/mailboxes/selectors";
import { IRule } from "store/entities/rules/interfaces";
import { selectIsTagsFetching, selectTagsAlphabetically } from "store/entities/tags";
import { selectIsTeamsFetching, selectTeamsAlphabetically } from "store/entities/teams";

import { validateActions, validateTriggers } from "./validators";

export function useRuleHasError(rule: IRule): boolean {
  const agents = useSelector(selectAgentsAlphabetically);
  const teams = useSelector(selectTeamsAlphabetically);
  const tags = useSelector(selectTagsAlphabetically);
  const cannedResponses = useSelector(selectCannedResponsesArray);
  const mailboxes = useSelector(selectMailboxesAlphabetically);

  const isAgentsFetching = useSelector(selectIsAgentsFetching);
  const isTeamsFetching = useSelector(selectIsTeamsFetching);
  const isTagsFetching = useSelector(selectIsTagsFetching);
  const isCannedResponsesFetching = useSelector(selectIsCannedResponsesFetching);
  const isMailboxesFetching = useSelector(selectIsMailboxesFetching);

  const isValidationDataFetching =
    isAgentsFetching || isTeamsFetching || isTagsFetching || isCannedResponsesFetching || isMailboxesFetching;

  return useMemo(() => {
    if (isValidationDataFetching) {
      return false;
    }

    return (
      validateActions(rule.actions, teams, agents, cannedResponses, tags).some(error => error) ||
      validateTriggers(rule.triggers, tags, teams, agents, mailboxes).some(error => error)
    );
  }, [rule, agents, teams, tags, cannedResponses, mailboxes, isValidationDataFetching]);
}
